// import {
//   TextField,
//   InputAdornment,
//   Icon,
//   IconButton,
//   Button,
// } from "@mui/material";
import React, { useState } from 'react';
import styles from "./HeaderComponent.module.css";

function LeagueNameInput({ value, onChange}) {
  // State to manage the placeholder text
  const [placeholder, setPlaceholder] = useState('Enter league name here');

  // Event handler for when the input is focused
  const handleFocus = () => {
    setPlaceholder('');
  };

  // Event handler for when the input is blurred
  const handleBlur = () => {
    // if (!inputValue) {
    if (!value) {
      setPlaceholder('Enter league name here');
    }
  };

  // State to manage the input value
  // const [inputValue, setInputValue] = useState('');

  return (
    <div>
      <input
        className={styles.enterLeagueName}
        type="text"
        label="League name"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </div>
  );
}

export default LeagueNameInput;
